import React from "react";

export const MadsMark = ({ className = "h-7 w-auto", ...props }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    aria-label="mads logo"
    {...props}
  >
    <rect width="64" height="64" rx="14" fill="none" />
    <text
      x="8"
      y="46"
      fontFamily="Playfair Display, Georgia, serif"
      fontStyle="italic"
      fontWeight="700"
      fontSize="44"
      fill="#2A2118"
    >
      m
    </text>
    <circle cx="52" cy="44" r="4.5" fill="#C9501C" />
  </svg>
);

export const MadsWordmark = ({ className = "", ...props }) => (
  <span
    className={`font-serif-display italic font-bold tracking-tight text-[#2A2118] ${className}`}
    {...props}
  >
    mads<span className="text-[#C9501C] not-italic">.</span>
  </span>
);
